module.exports = __webpack_public_path__ + "img/dead-dry-hairy-tree-07.45946534.png";